/**
 * "Estilo" do marker da malha.
 *
 * O Google Maps não renderiza DOM para os markers, então não há styled-component
 * possível aqui: a aparência é a config de `icon`/`label` passada à API. Fica neste
 * arquivo pelo mesmo motivo que os styled ficam — o componente não carrega aparência.
 */

/** Pin de mapa (Material "place"), desenhado em uma viewBox de 24x24. */
const PATH_PIN = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z'

/** Ícone do pin. `cor` vem da análise à qual o ponto pertence; sem análise, fica branco. */
export const iconePontoMalha = (cor?: string | null): google.maps.Symbol => ({
    path: PATH_PIN,
    fillColor: cor || '#ffffff',
    fillOpacity: 1,
    strokeWeight: 1,
    strokeColor: '#2c2c2c',
    scale: 1.5,
    /* Ancora na ponta do pin e centraliza o número na cabeça, não na viewBox. */
    anchor: new google.maps.Point(12, 22),
    labelOrigin: new google.maps.Point(12, 9),
})

/**
 * Número do ponto sobre o pin — escurece quando o pin está branco, para manter contraste.
 *
 * O peso da fonte carrega o terceiro estado: um ponto que não está selecionado agora mas
 * já pertence a outra análise vem em negrito, enquanto o que nunca foi usado fica com o
 * traço mais leve. Sem isso, em malhas de centenas de pontos os dois casos ficam
 * idênticos (pin branco) e o usuário não distingue "ainda falta" de "já cuidei disso".
 *
 * O selecionado não precisa do peso — a cor do pin já o separa dos dois.
 */
export const labelPontoMalha = (
    texto: string,
    cor?: string | null,
    ja_usado?: boolean
): google.maps.MarkerLabel => ({
    text: texto,
    color: cor ? 'white' : ja_usado ? '#5a5a5a' : '#9e9e9e',
    /* 500 (e não o 'normal') mantém o número legível sobre o satélite; o contraste com o 700 vem do par. */
    fontWeight: cor || ja_usado ? '700' : '500',
    fontSize: '10px',
})
